import { Box, Heading } from '@chakra-ui/react';
import BottomNavBar from '@/components/BottomNavBar';
import HouseholdSection from '@/components/HouseholdSection';

export default function Household() {
  return (
    <Box minH="100vh" bg="bg.canvas" pb={{ base: '130px', lg: 0 }}>
      <Box h="env(safe-area-inset-top, 0px)" />
      <Box maxW="600px" pl={{ base: 4, lg: 8 }} pr={4} pt={{ base: 5, lg: 8 }}>
        <Heading
          fontFamily="heading"
          fontWeight="800"
          fontSize={{ base: 'xl', lg: '2xl' }}
          color="text.primary"
          mb={6}
        >
          Household
        </Heading>
        <HouseholdSection />
      </Box>

      <BottomNavBar />
    </Box>
  );
}
